'use client';

import { c as _c } from "react/compiler-runtime";
import { AlertCircleOutline } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Button, DialogTrigger } from 'react-aria-components';
import { Link } from '~/components/Link';
import { Popover } from '~/components/Popover';
import styles from '../TripOverviewPage.module.css';
const carbonFormatter = new Intl.NumberFormat('en-GB', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
type EmissionsBadgeProps = {
  savingsPercentForBadge: number;
  totalCarbonFootprint: number;
  formattedCarbonSavings: number | undefined;
  hasUsageComparisons: boolean;
  journeyCarbonUsage?: {
    carEquivalent: number;
    flightEquivalent: number;
  };
};
export function EmissionsBadge(t0) {
  const $ = _c(37);
  const {
    savingsPercentForBadge,
    totalCarbonFootprint,
    formattedCarbonSavings,
    hasUsageComparisons,
    journeyCarbonUsage
  } = t0;
  const t = useTranslations("journey");
  const commonT = useTranslations("common");
  let t1;
  if ($[0] !== t) {
    t1 = t("overview_emissions_show_comparison");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== savingsPercentForBadge || $[3] !== t) {
    t2 = t("carbon_savings_tag", {
      percent: savingsPercentForBadge
    });
    $[2] = savingsPercentForBadge;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <AlertCircleOutline decorative={true} width={24} height={24} />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <span className={styles.emissionsBadge}>{t2}{t3}</span>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <Button data-ua-click="carbon-savings-button" className={styles.emissionsBadgeButton} aria-label={t1}>{t4}</Button>;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("carbon_heading");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("carbon_heading");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <h3 className={styles.emissionsPopoverHeading}>{t7}</h3>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== formattedCarbonSavings || $[18] !== hasUsageComparisons || $[19] !== journeyCarbonUsage || $[20] !== t || $[21] !== totalCarbonFootprint) {
    t9 = hasUsageComparisons && typeof formattedCarbonSavings === "number" ? <><ul className={styles.emissionsPopoverList}><li className={styles.emissionsPopoverItem}><span className={styles.emissionsPopoverLabelStrong}>{t("carbon_this_trip")}</span><span className={styles.emissionsPopoverValueStrong}>{carbonFormatter.format(totalCarbonFootprint)} kg CO<sub>2</sub></span></li><li className={styles.emissionsPopoverItem}><span>{t("carbon_driving")}</span><span>{carbonFormatter.format(journeyCarbonUsage.carEquivalent)} kg CO<sub>2</sub></span></li><li className={styles.emissionsPopoverItem}><span>{t("carbon_flying")}</span><span>{carbonFormatter.format(journeyCarbonUsage.flightEquivalent)} kg CO<sub>2</sub></span></li></ul><p className={styles.emissionsPopoverBody}><strong>{t(formattedCarbonSavings < 0 ? "carbon_comparison_fewer" : "carbon_comparison_more", {
            percent: Math.abs(formattedCarbonSavings)
          })}</strong>{" "}{t("carbon_note")}</p></> : <p className={styles.emissionsPopoverBody}>{t("carbon_note")}</p>;
    $[17] = formattedCarbonSavings;
    $[18] = hasUsageComparisons;
    $[19] = journeyCarbonUsage;
    $[20] = t;
    $[21] = totalCarbonFootprint;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== commonT) {
    t10 = commonT("learn_more");
    $[23] = commonT;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10) {
    t11 = <Link hasUnderline={true} href="https://www.byway.travel/blog/new-feature-alert-carbon-labelling-for-every-trip">{t10}</Link>;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t8 || $[29] !== t9) {
    t12 = <div className={styles.emissionsPopoverContent}>{t8}{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t8;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t12 || $[32] !== t6) {
    t13 = <Popover hasArrow={true} ariaLabel={t6}>{t12}</Popover>;
    $[31] = t12;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t5) {
    t14 = <DialogTrigger>{t5}{t13}</DialogTrigger>;
    $[34] = t13;
    $[35] = t5;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  return t14;
}